let taxBenefitTarifs;
let allowanceTarifs;
let maxBenefitTariffsKm=0;
let coEmission=0;
let possiblePrizes=[];
$(document).ready(function() {
    /**get prices*/
    const basePriceByKm=$(".main-container").data("base-price");
    const driverPrice=$(".main-container").data("driver-price");
    const co2ByTree=20;
    let taxBenefitWithoutCarpooling=0;

    $.ajax({
        async: false,
        url: "/ajax/prices/", success: function(result){
            taxBenefitTarifs=result.data;
            allowanceTarifs=result["allowance"];
            coEmission=parseFloat(result["base-co2"])/1000;
            taxBenefitWithoutCarpooling=parseFloat(result["forfait"]);
            maxBenefitTariffsKm= Math.max.apply(null, taxBenefitTarifs.map(function (event) {
                return event.km;
            }));
        }
});

    $.ajax({
        async: false,
        url: "/ajax/prizes/", success: function(result){
            possiblePrizes=result.data;
        }
    });
    $(".ecological-benefit .calculation-description").parent().addClass("d-none");
    $(".distance-wrapper input").focus();

    $('.goto-btn').click(function(e) {
        e.preventDefault();
        if($(this).hasClass("btn-role")){
            $(".btn-role").removeClass("active");
            $(this).addClass("active");

        }
        updateActiveSlide($(this));
    });
    $('.btn-type-benefit').click(function(e) {
        $('.btn-type-benefit').removeClass("active");
        let myType=$(this).data("role");
        $(this).addClass("active");
        $("."+myType).addClass("active");
        updateActiveBenefit();
    });


    $( ".slider" ).each(function( index ) {
        $(this).data("background-color", $(this).css( "background-color" ))
        updateProgress($(this));
    });
    if($(".slider").length>0){
        activeSliderColor=$(".slider").css( "background-color" );
        updateProgress($(".slider"));

    }

    function updateActiveSlide(nextSlide){
        $(".slide.active").find("input.required-field").removeClass("error");
        let hasErrors=false;
        $(".slide.active").find("input.required-field").each(function(index) {
            if(!$(this).val()){
                $(this).addClass("error");
                hasErrors=true;
            }
        })
        if( $(".slide.active").hasClass("slide-1")){
            $(".error-message").text("");
            validateDistance();
            if($("#distance").hasClass("error")){
                hasErrors=true;
                $(".error-message").html('<div class="alert alert-danger">'+$("#distance").data("error")+'</div>');
            }
        }
        if(!hasErrors) {
            $(".slide.active").removeClass("active");
            let slideToGo = nextSlide.data("slide-to");
            $(".slide-" + slideToGo).addClass("active");

        if(slideToGo===4) {
            updateActiveBenefit();
        }
            if(slideToGo===5) {
                calculateTaxBenefit();
                calculateEcologicalBenefit();
                calculateEconomicalBenefit();
                $(".role-labels .role-label").addClass("d-none");
                $(".role-labels").find("."+$(".btn-role.active").data("role")).removeClass("d-none");

                $(".all-benefits  .info-by-type-container").addClass("d-none");
                $(".all-benefits").find("."+$(".btn-type-benefit.active").data("role")).removeClass("d-none");
            }
        }
    }
    /* slide 3*/
    $(".slider").change(function(event){
        if($(this).val()=="0"){
            $(this).val("1");
        }
        updateProgress($(this));
        if($(this).attr('id')==="number-days"){
            $("#number-days-readonly").val($(this).val());
            updateProgress($("#number-days-readonly"));
        }else{
            $("#number-days").val($(this).val());
            updateProgress($(this));
            updateProgress($("#number-days"));
            updateActiveBenefit();
        }
    });

    function updateProgress(tempSlider){
       $(".number-days-value").text(tempSlider.val())
        let activeSliderColor=tempSlider.data("background-color");
       let progress = (tempSlider.val() / tempSlider[0].max) * 100;
        tempSlider.css('background', `linear-gradient(to right, ${tempSlider.css( "border-color" )} ${progress}%, ${activeSliderColor} ${progress}%)`);
    }
    function validateDistance(){
        $("#distance").addClass("error");
        let distance=parseFloat($("#distance").val().replace(/,/g, '.'));

        if(distance>0 && distance<=300){
            $("#distance").removeClass("error");
            if((distance % 1)>0){
                $("#distance").val(distance.toFixed(1));
            }else{
            $("#distance").val(distance);
            }
        }
    }
    function calculateTaxBenefit(){
        let distance=$("#distance").val();
        distance=parseInt(distance, 10);
        let taxBenefitByMonth = 0;
        let allowanceBenefit =0;
        if(distance>maxBenefitTariffsKm){
            taxBenefitByMonth=taxBenefitTarifs.find(({km}) => km == maxBenefitTariffsKm).euro;
        }else{
            taxBenefitByMonth=taxBenefitTarifs.find(({km}) => km == distance).euro;
        }
        allowanceBenefit=allowanceTarifs.find(({km}) => km == distance).euro;
        let taxBenefitByDay=parseFloat(taxBenefitByMonth)/20;


        let estimatedDaysOff=30/5*$("#number-days").val();

    let totalBenefit=taxBenefitByDay*($("#number-days").val()*52-estimatedDaysOff); //calculate for 52 weeks (a year) - 30 days (days off)
        if(totalBenefit<taxBenefitWithoutCarpooling){
            totalBenefit=taxBenefitWithoutCarpooling;
        }
        if(totalBenefit>parseFloat(allowanceBenefit)){
            totalBenefit=parseFloat(allowanceBenefit);
        }
let extraBenefit=(totalBenefit-470)*0.45;
        let totalFiscalBenefit=totalBenefit*0.45;
        if(extraBenefit<0){
            extraBenefit=0;
        }
        $(".tax-benefit .benefit-by-month").text(extraBenefit.toFixed(2));
        $(".tax-benefit .benefit-by-day-container").hide();

        $(".tax-benefit-effective").text(totalBenefit.toFixed(2));
        $(".tax-benefit .calculation-description").text('(€'+parseFloat(totalBenefit).toFixed(2)+" - 470) x 0,45");

        let myPrize;
        $.each( possiblePrizes, function( index, currentPrize ){
            if(totalFiscalBenefit>parseInt(currentPrize.price_min)){
                myPrize=currentPrize;
            }
        });
        $(".description-prize").text(myPrize.description);
        $(".prize-pic img").attr("src",$(".prize-pic img").data("src")+myPrize.photo);
        updateBenefit("€"+Math.round(totalFiscalBenefit), "tax");
    }
    function calculateEconomicalBenefit(){
        let distance=parseFloat($("#distance").val())*2;
        let priceByKm=driverPrice;
        let activeRoleButton = $(".btn-role.active");

        if (activeRoleButton.hasClass("passenger-role")) {
            priceByKm=basePriceByKm-driverPrice;
        }
        if (activeRoleButton.hasClass("both-role")) {
            priceByKm=(basePriceByKm-driverPrice)/2+driverPrice/2;
        }

        $(".economical-benefit .benefit-by-km").text('€'+parseFloat(priceByKm).toFixed(2));
        let benefitByDay=priceByKm*distance;
        $(".economical-benefit .benefit-by-day").text('€'+benefitByDay.toFixed(2));
        $(".economical-benefit .calculation-description").text('€'+parseFloat(priceByKm).toFixed(2)+" x "+$("#distance").val()+"km"+" x 2");
        let estimatedDaysOff=30/5*$("#number-days").val();
        let totalBenefit=benefitByDay*($("#number-days").val()*52-estimatedDaysOff); //calculate for 52 weeks (a year) - 30 days (days off)
        updateBenefit("€"+Math.round(totalBenefit), "economical");
        let myPrize;
            $.each( possiblePrizes, function( index, currentPrize ){
            if(totalBenefit>parseInt(currentPrize.price_min)){
                myPrize=currentPrize;
            }
        });
        $(".description-prize").text(myPrize.description);
        $(".prize-pic img").attr("src",$(".prize-pic img").data("src")+myPrize.photo);

    }
    function calculateEcologicalBenefit(){
        let distance=parseFloat($("#distance").val())*2;
        let estimatedDaysOff=30/5*$("#number-days").val();

        let benefitByKm=(coEmission-0.066);
        let activeRoleButton = $(".btn-role.active");
        if (activeRoleButton.hasClass("passenger-role")) {
            benefitByKm=(coEmission-0.047);
        }
        if (activeRoleButton.hasClass("both-role")) {
            benefitByKm=((coEmission-0.066)+(coEmission-0.047))/2;
        }
        let benefitByDay=(benefitByKm * distance);
        $(".co2-emission-by-type").text(benefitByKm.toFixed(2));
        $(".ecological-benefit .benefit-by-km").text(benefitByKm.toFixed(2)+'kg');
        $(".ecological-benefit .benefit-by-day").text(benefitByDay.toFixed(2)+'kg');
        //let ecologicalBenefitByWeek=(distance*$("#number-days").val()*coEmission).toFixed(2);
        let totalEcologicalBenefit=benefitByDay*($("#number-days").val()*52-estimatedDaysOff); //calculate for 52 weeks (a year) - 30 days (days off)
        $(".description-prize").text("");
        $(".prize-pic img").attr("src",$(".prize-pic img").data("src")+"trees.png");
        updateBenefit(Math.round(totalEcologicalBenefit), "ecological"); //calculate  for 52 weeks (a year) - 30 days (days off)
        let amountTrees=Math.round(totalEcologicalBenefit/co2ByTree);
        $(".amount-trees").text(amountTrees);
    }
    function updateBenefit(benefit, type) {
        let activeButton = $(".slide-4").find(".btn-type-benefit.active")
        if (activeButton.hasClass(type+"-benefit")) {
            $(".slide-4 .saved-amount").text(benefit);
        }
        $("."+type+"-benefit .saved-amount").text(benefit);
        //$(".saved-amount").css("margin-left", ($(".saved-amount").parent().width()/2 - $(".saved-amount").width()/2));
    }

    function updateActiveBenefit(){
        let activeButton = $(".slide-4").find(".btn-type-benefit.active")
        if (activeButton.hasClass("tax-benefit")) {
            calculateTaxBenefit();
            $(".show-on-tax-benefit").css("display", "block");
            $(".show-on-economical-benefit").css("display", "none");
            $(".show-on-ecological-benefit").css("display", "none");
            $(".trees-line").addClass("d-none");

        }else if (activeButton.hasClass("economical-benefit")) {
                calculateEconomicalBenefit();
                $(".show-on-economical-benefit").css("display", "block");
                $(".show-on-tax-benefit").css("display", "none");
            $(".show-on-ecological-benefit").css("display", "none");
            $(".trees-line").addClass("d-none");

        }else if(activeButton.hasClass("ecological-benefit")) {
            calculateEcologicalBenefit();
            $(".show-on-economical-benefit").css("display", "none");
            $(".show-on-tax-benefit").css("display", "none");
            $(".show-on-ecological-benefit").css("display", "block");
            $(".trees-line").removeClass("d-none");

        }
        $(".all-benefits  .info-by-type-container").addClass("d-none");
        $(".all-benefits").find("."+$(".btn-type-benefit.active").data("role")).removeClass("d-none");
    }
});